// 验证表单
import {ElMessage} from "element-plus";

export const validateForm = (ruleFormRef)=>{
    if (!ruleFormRef){
        // ElMessage.warning("请填写完整的信息")
        return  Promise.resolve(false)
    }
    return new Promise((resolve) => {
        ruleFormRef.validate((valid)=>{
            if (valid) {
                resolve(true)
            }
        }).then(()=>{
            // ElMessage.warning("请填写完整的信息")
            resolve(false)
        })
    })
}
/**
 * 验证身份证
 * DocuentType：1。身份证，2，护照，身份证做验证，护照
 * @param DocuentType
 * @param value
 */
export function validateCardId(DocuentType,value){
    var reg = /^([a-zA-z]|[0-9]){5,17}$/; // 护照正则
    var reg2 = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}[0-9Xx]$/; // 大陆身份证正则
    if(!value || !value.trim()){
        return false
    }
    if(DocuentType==1){
        return reg2.test(value)
    }else{
        return reg.test(value)
    }

}
